module.exports = __webpack_public_path__ + "media/images/pic/teachers/wiktoria-piontek-ba373540fe0cff017553b57444208e51.webp";